export class EnvironmentVariables {
    public static readonly ApiUrl: string = import.meta.env.VITE_API_URL;
    public static readonly AuthUrl: string = import.meta.env.VITE_AUTH_URL;
}
